import { css, html, LitElement } from 'lit'
import { customElement, property, state } from 'lit/decorators.js'
import { ifDefined } from 'lit/directives/if-defined.js'

import { ScrollbarStyles } from '@operato/styles'

import './board-basic-info.js'
import './board-info-link.js'

@customElement('board-info')
export class BoardInfo extends LitElement {
  static styles = [
    ScrollbarStyles,
    css`
      :host {
        height: 100%;
        min-width: 360px;

        display: flex;
        flex-direction: column;
        position: relative;
        background-color: var(--md-sys-color-surface);
      }

      [tab] {
        width: 100%;
        display: flex;
      }

      [tab] > * {
        flex: 1;
      }

      [content] {
        flex: 1;
        overflow-y: auto;
      }

      span {
        padding: 5px 4px 1px;
        font: var(--group-bar-textbutton);
        background-color: var(--md-sys-color-secondary);
        color: rgba(255, 255, 255, 0.8);
        text-align: center;
        text-transform: uppercase;
      }

      span[active] {
        background-color: var(--md-sys-color-primary);
      }

      @media screen and (max-width: 460px) {
        :host {
          width: 100vw;
        }
      }
    `
  ]

  @property({ type: Object }) board?: { id: string; name: string }

  @state() tab: string = 'basic'

  render() {
    return html`
      <div tab>
        <span @click=${() => (this.tab = 'basic')} ?active=${this.tab == 'basic'}>basic</span>
        <span @click=${() => (this.tab = 'link')} ?active=${this.tab == 'link'}>link</span>
      </div>
      <div content>
        ${this.tab == 'basic'
          ? html`<board-basic-info boardId=${ifDefined(this.board?.id)}></board-basic-info>`
          : html`<board-info-link .board=${this.board}></board-info-link>`}
      </div>
    `
  }

  close() {
    history.back()
  }
}
